import React, { useEffect, useState } from 'react'
import { Link, useHistory, withRouter } from 'react-router-dom'
import {
  getCreateEventData,
  getUserInfo,
  removeCreateEventData,
} from '_utils/localData'
import { useSelector } from 'react-redux'
import useBlockFeatureCheck from '_hooks/useBlockFeatureCheck'
import './style.scss'

const Footer = ({ location }) => {
  const history = useHistory()
  const [pathname, setPathname] = useState(location.pathname.split('/'))
  const { myEvents } = useSelector((state) => state.event)
  const currentUser = getUserInfo()
  const { checkAndProceed, BlockPopup } = useBlockFeatureCheck()
  const isAllowHost =
    currentUser?.groups?.length && currentUser?.groups?.some((g) => g?.isHost || g?.isAdmin)

  const checkHighLight = () => {
    const paths = [
      'create',
      'create-items',
      'created-confirm',
      'update',
      'update-items',
      'update-confirm',
      'hosting'
    ]
    if (pathname[1] === 'event' && paths.includes(pathname[2].split('?')[0])) {
      return true
    }
    return false
  }

  const handleOnClickToCreateEvent = async () => {
    checkAndProceed(() => {
      const eventData = getCreateEventData()
      if (eventData?.id) {
        removeCreateEventData()
      }
      history.push('/event/hosting')
    })
  }

  useEffect(() => {
    setPathname(location.pathname.split('/'))
  }, [location])

  const positionSticky = {
    position: 'sticky',
    flex: '0 0 auto',
  }

  return (
    <>
      {isAllowHost && (
        <footer className={'footer-admin-desktop mt-auto'} style={positionSticky}>
          <div className='container-fluid footer-admin-desktop-box'>
            <ul className='menu-desktop footer-admin w-100'>
              <li>
                <a
                  className={checkHighLight() ? 'active' : ''}
                  onClick={handleOnClickToCreateEvent}
                >
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <line x1='12' y1='5' x2='12' y2='19' />
                    <line x1='5' y1='12' x2='19' y2='12' />
                  </svg>
                  <span>New Event</span>
                </a>
              </li>
              <li>
                <Link
                  to='/event/list-hosted-by-group'
                  className={
                    pathname[1] === 'event' && pathname[2] === 'list-hosted-by-group'
                      ? 'active'
                      : ''
                  }
                >
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <rect x='3' y='4' width='18' height='18' rx='2' />
                    <line x1='16' y1='2' x2='16' y2='6' />
                    <line x1='8' y1='2' x2='8' y2='6' />
                    <line x1='3' y1='10' x2='21' y2='10' />
                  </svg>
                  <span>
                    Hosted Event{' '}
                    {Boolean(myEvents?.length) && (
                      <span className='badge-count'>({myEvents?.length})</span>
                    )}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </footer>
      )}
      {BlockPopup}
    </>
  )
}

export default withRouter(Footer)
